import axios, { CreateAxiosDefaults } from 'axios';
import { getApiServerUrl } from '../shared/utils/auth/mandant';
import {isBearerTokenAuthEnabled} from "../shared/utils/auth/auth";

const baseUrl = `${getApiServerUrl()}/api/v1`;

const buildPaginationQuery = (
  baseUrl: string,
  pageSize: number = 10,
  pageIndex: number = 0,
  search?: string,
  appIds?: number[]
) => {
  const params = new URLSearchParams();
  if (pageSize !== undefined) params.append('pageSize', String(pageSize));
  if (pageIndex !== undefined) params.append('pageIndex', String(pageIndex));
  if (search) params.append('search', search);
  if (appIds && appIds.length > 0) {
    params.append('appIds', String(appIds?.join(',')));
  }
  return params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
};

/**
 * Some API Endpoints like /verfahren are indepent from an startApp and therefore do not need a startAppId in theory, but due to our current impelementation it is required.
 * Most of the endpoints can be called with the static startAppId or rather without an id to be indepent from an startApp and mandant friendly.
 */
export const ApiRoutes = {
  mandant: () => `/mandant`,
  mandantUser: () => `/mandant/user`,
  profile: () => `/profile`,

  tentants: () => `/tenants`,
  userByTenant: (tenantId: string) => `/tenants/${tenantId}/users`,
  usersInvite: () => `/usermanagement/users/invite`,
  users: () => `/usermanagement/users`,
  user: (userId: string) => `/usermanagement/users/${userId}`,
  availableRoles: () => `/usermanagement/roles`,
  changeEmail: () => `/usermanagement/users/me/email`,
  changePassword: () => `/usermanagement/users/me/password`,
  userWithAuthorizations__: (page: number, size: number) =>
    `/usermanagement/users?page=${page}&size=${size}`
};

export const userConflictErrorMsg =
  'Diese E-Mail-Adresse ist bereits registriert.';

export const apiConfig: CreateAxiosDefaults = {
  withCredentials: !isBearerTokenAuthEnabled(),
  baseURL: baseUrl
};

export const mandantClient = axios.create(apiConfig);
